import { Line3, Vector3 } from "three"
import { AppDispatch, AppGetState } from ".."
import type { Door } from "./types"
import { guid } from "~/lib/utils"
import { distributeDoors } from "./actions"

function vector(isHorizontal: boolean, isInverted: boolean): Vector3 {
  if (isHorizontal) {
    if (isInverted) {
      return new Vector3(0, +1, 0)
    } else {
      return new Vector3(0, -1, 0)
    }
  } else {
    if (isInverted) {
      return new Vector3(-1, 0, 0)
    } else {
      return new Vector3(+1, 0, 0)
    }
  }
}

export const makeAndDistributeDoors = (door: Door, count: number, distance: number, isHorizontal: boolean, isInverted: boolean) => (dispatch: AppDispatch, getState: AppGetState) => {
  const direction = vector(isHorizontal, isInverted)
  const currentPosition = new Vector3()
  const models: Door[] = []
  const attachedSegment = getState().objects.present.segments[door.wallSegmentId]
  const segmentLine = new Line3(
    new Vector3().copy(attachedSegment.startPoint),
    new Vector3().copy(attachedSegment.endPoint),
  )

  for (let i = 0; i < count; i++) {
    currentPosition.copy(door.position).addScaledVector(direction, (i+1) * distance)

    const parameter = segmentLine.closestPointToPointParameter(currentPosition, false)
    if (parameter < 0 || parameter > 1) {
      break
    }

    models.push({
      ...door,
      id: guid(),
      position: {
        x: currentPosition.x,
        y: currentPosition.y,
        z: currentPosition.z,
      },
    })
  }

  dispatch(distributeDoors({
    models,
  }))
}
